module.exports = __webpack_public_path__ + "img/icon-65.3b640047.png";